<template>
<ItpButton
  :spinning="actions.submit.isRunning"
  variant="primary"
  :size="size"
  :text="messages.bntText"
  :tooltip="messages.btnTooltip"
  @click.prevent.stop="evh_7315092382398562_clickPreventStop($event, {})"
>
</ItpButton>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BtnIssueInvoice extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "Kérem erősítse meg a számla kiállítását! A kiállított számla utólag már nem módosítható.\n",
  })
  confirmMessage!: string;

  @Watch('confirmMessage')
  onConfirm_message(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("confirmMessage")
  }

  @Prop({
    type: String,
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  @Prop({
    type: String,
    default: "self",
  })
  target!: string;

  @Watch('target')
  onTarget(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("target")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          bntText: "Számla kiállítása",
          btnTooltip: "A számla véglegesítése és kiállítása.",
        }
        ,
        ux: null,
      },
    }
  }

  async act_7315092382398562_emit_7358_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_7358, alias=undefined
    return {
      event: "success",
    }
  }

  async act_7315092382398562_request_7356_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7315092382398562_request_7356, alias=submit
    return {
      operation: "update_invoice_status",
      data: { id: this.invoice.id, status: 'completed', etag: this.invoice.etag },
    }
  }

  async act_7315092382398562_request_7356_getConfirm($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7315092382398562_request_7356, alias=submit
    return {
      header: "Számla kiállítása",
      message: this.confirmMessage,
      btnOk: "Számla kiállítása",
      btnCancel: "Mégsem",
      severity: "warning",
    }
  }

  async evh_7315092382398562_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_7358: actions.EmitAction;
    evh_7315092382398562_success_7357: actions.EventHandlerImpl;
    act_7315092382398562_request_7356: actions.RequestAction;
    evh_7315092382398562_clickPreventStop_7355: actions.EventHandlerImpl;
    evh_7315092382398562_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_7358 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_7358_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_success_7357 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_7358,
        event: "success",
        displayName: "emit",
      }
    );
    const act_7315092382398562_request_7356 = new actions.RequestAction(
      {
        actionArgs: this.act_7315092382398562_request_7356_getActionArgs,
        confirm: this.act_7315092382398562_request_7356_getConfirm,
        displayName: "submit",
        events: [evh_7315092382398562_success_7357],
      }
    );
    const evh_7315092382398562_clickPreventStop_7355 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_request_7356,
        event: "click.prevent.stop",
        displayName: "submit",
      }
    );
    const evh_7315092382398562_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_clickPreventStop_7355],
      }
    );
    return {
      act_7315092382398562_emit_7358,
      evh_7315092382398562_success_7357,
      act_7315092382398562_request_7356,
      evh_7315092382398562_clickPreventStop_7355,
      evh_7315092382398562_clickPreventStop,
      submit: act_7315092382398562_request_7356,
    }
  }
}

Vue.component("BtnIssueInvoice", BtnIssueInvoice);

</script>